(function () {
  'use strict';

  var desktopQuery = window.matchMedia('(min-width: 992px)');

  function isDesktop() {
    return desktopQuery.matches;
  }

  function isVisible(element) {
    if (!element || !isDesktop()) {
      return false;
    }

    var styles = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();

    return styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      rect.width > 0 &&
      rect.height > 0;
  }

  function firstMatch(selectors) {
    for (var index = 0; index < selectors.length; index += 1) {
      var element = document.querySelector(selectors[index]);

      if (element) {
        return element;
      }
    }

    return null;
  }

  function ensureId(element, fallbackId) {
    if (!element) {
      return '';
    }

    if (!element.id) {
      element.id = fallbackId;
    }

    return element.id;
  }

  function initDesktopFoundation() {
    if (!document.body || document.body.dataset.jillleenDesktopFoundation === 'ready') {
      return;
    }

    document.body.dataset.jillleenDesktopFoundation = 'ready';

    var activeTrigger = null;
    var controls = [
      {
        name: 'search',
        trigger: '[data-search-mobile-toggle]',
        target: ['.site-header.header-parallax .nav-search > .search-form', '#search-form-mobile'],
        label: 'Open search'
      },
      {
        name: 'account',
        trigger: '[data-user-mobile-toggle]',
        target: ['#dropdown-customer', '.site-header.header-parallax .customer-links'],
        label: 'Open account menu'
      },
      {
        name: 'cart',
        trigger: '[data-cart-toggle]',
        target: ['#dropdown-cart', '.cart-sidebar', '.wrapper-top-cart'],
        label: 'Open shopping bag'
      },
      {
        name: 'options',
        trigger: '[data-show-options]',
        target: ['.site-header.header-parallax .lang-currency-groups'],
        label: 'Open language and currency options'
      }
    ];

    controls.forEach(function (control) {
      document.querySelectorAll(control.trigger).forEach(function (trigger, triggerIndex) {
        var target = firstMatch(control.target);
        var targetId = ensureId(target, 'jillleen-' + control.name + '-panel-' + triggerIndex);

        trigger.setAttribute('aria-label', control.label);
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-expanded', 'false');

        if (targetId) {
          trigger.setAttribute('aria-controls', targetId);
        }

        trigger.addEventListener('click', function () {
          if (!isDesktop()) {
            return;
          }

          activeTrigger = trigger;

          window.setTimeout(function () {
            if (!isDesktop()) {
              return;
            }

            var expanded = target ? isVisible(target) : trigger.getAttribute('aria-expanded') !== 'true';
            trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');

            if (expanded && target) {
              var focusTarget = target.querySelector('input:not([type="hidden"]), button, a[href], select, textarea, [tabindex]:not([tabindex="-1"])');

              if (focusTarget) {
                focusTarget.focus({ preventScroll: true });
              }
            }
          }, 120);
        });
      });
    });

    var closeSelector = [
      '[data-search-close-sidebar]',
      '.close-search',
      '[data-cart-close]',
      '.close-cart',
      '[data-user-close]',
      '.close-customer',
      '.close-option'
    ].join(',');

    document.addEventListener('click', function (event) {
      if (!isDesktop() || !event.target.closest(closeSelector)) {
        return;
      }

      window.setTimeout(function () {
        document.querySelectorAll('[aria-expanded="true"][data-search-mobile-toggle], [aria-expanded="true"][data-user-mobile-toggle], [aria-expanded="true"][data-cart-toggle], [aria-expanded="true"][data-show-options]').forEach(function (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        });

        if (activeTrigger) {
          activeTrigger.focus({ preventScroll: true });
        }
      }, 80);
    });

    document.addEventListener('keydown', function (event) {
      if (!isDesktop() || event.key !== 'Escape') {
        return;
      }

      var visibleClose = Array.prototype.find.call(document.querySelectorAll(closeSelector), isVisible);

      if (visibleClose) {
        event.preventDefault();
        visibleClose.click();
      }
    });

    document.querySelectorAll('.site-header.header-parallax .site-nav > .menu-lv-1.dropdown').forEach(function (item) {
      var link = item.querySelector(':scope > a');

      if (!link) {
        return;
      }

      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');

      item.addEventListener('mouseenter', function () {
        if (isDesktop()) {
          link.setAttribute('aria-expanded', 'true');
        }
      });

      item.addEventListener('mouseleave', function () {
        if (isDesktop() && !item.contains(document.activeElement)) {
          link.setAttribute('aria-expanded', 'false');
        }
      });

      item.addEventListener('focusin', function () {
        if (isDesktop()) {
          link.setAttribute('aria-expanded', 'true');
        }
      });

      item.addEventListener('focusout', function () {
        if (!isDesktop()) {
          return;
        }

        window.setTimeout(function () {
          if (!item.contains(document.activeElement)) {
            link.setAttribute('aria-expanded', 'false');
          }
        }, 0);
      });
    });

    var cookieBanner = document.querySelector('#accept-cookies');

    if (cookieBanner) {
      cookieBanner.setAttribute('role', 'region');
      cookieBanner.setAttribute('aria-label', 'Cookie preferences');
    }

    var scrollQueued = false;

    function updateHeaderState() {
      if (!isDesktop()) {
        return;
      }

      document.body.classList.toggle('jillleen-header-is-scrolled', window.scrollY > 12);
      scrollQueued = false;
    }

    function syncFoundationState() {
      if (isDesktop()) {
        document.body.classList.add('jillleen-desktop-foundation-ready');
        updateHeaderState();
        return;
      }

      document.body.classList.remove('jillleen-desktop-foundation-ready', 'jillleen-header-is-scrolled');
      scrollQueued = false;
    }

    syncFoundationState();

    window.addEventListener('scroll', function () {
      if (!isDesktop() || scrollQueued) {
        return;
      }

      scrollQueued = true;
      window.requestAnimationFrame(updateHeaderState);
    }, { passive: true });

    desktopQuery.addEventListener('change', syncFoundationState);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDesktopFoundation, { once: true });
  } else {
    initDesktopFoundation();
  }
}());
